export class UnreachableCodeError extends Error {
  constructor(_: never, message = 'Unreachable code encountered.') {
    super();
    this.name = 'UnreachableCodeError';
    this.message = message;
    this.cause = _;
  }
}
